export default __webpack_public_path__ + "static/media/tv-and-modem.827b66e3.png";